import { gql } from '@apollo/client';

export const ALL_DELIVERY_TIME_INTERVAL_FIELDS_FRAGMENT = gql`
  fragment fullDeliveryTimeIntervalsFragment on intervals {
        id
        region_name
        has_morning_deliveries
        has_evening_deliveries
        morning_intervals {
            time_from
            time_to
        }
        evening_intervals {
            time_from
            time_to
        }
        days_of_week_for_morning_delivery
        days_of_week_for_evening_delivery
        deliveryTimesList @client
    }
`;

